import "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const waitForFinalEvent = (function () {
  const timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
    if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

const debounce = (func, wait = 1000) => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func.apply(null, args);
    }, wait);
  };
};

export function initScrollAnimation() {

  const topVisualTl = gsap.timeline();
  function resetTopVisual() {
    gsap.set("#mainvisual-docs", { scale: 0.88, opacity: 0});
    gsap.set("#mainvisual-device", { scale: 0.88, opacity: 0});
    topVisualTl.clear();
  }
  resetTopVisual();

  function animateTopVisual() {
    topVisualTl
        // .set("#mainvisual-docs", {opacity: 1})
        .to("#mainvisual-docs", {scale: 1, opacity: 1, duration: 1, delay: 0.4, ease: "elastic.out(1,0.8)"})
        // .set("#mainvisual-device", {opacity: 1}, "-=0.9")
        .to("#mainvisual-device", {scale: 1, opacity: 1, duration: 1, ease: "elastic.out(1,0.8)"}, "-=0.8")
  }
  ScrollTrigger.create({
    trigger: '#top-visual',
    start: 'top bottom-=48px',
    end: 'bottom top',
    // once: true,
    onEnter: (self) => {
      animateTopVisual()
    },
    onLeave: (self) => {
      resetTopVisual();
    },
    onEnterBack: (self) => {
      animateTopVisual()
    },
    onLeaveBack: (self) => {
      resetTopVisual();
    },
  });

  gsap.set('#cloud01', { y: "30%", scale: 0.8});
  gsap.to('#cloud01', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1,
    },
    y: "-60%",
  });

  gsap.set('#cloud02', { y: "10%", scale: 0.8});
  gsap.to('#cloud02', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 2,
    },
    y: "-40%",
  });

  gsap.set('#cloud03', { y: "120%", scale: 0.8});
  gsap.to('#cloud03', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1,
    },
    y: "-20%",
  });

  gsap.set('#cloud04', { y: "80%", scale: 0.8});
  gsap.to('#cloud04', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 3,
    },
    y: "20%",
  });

  gsap.set('#cloud-empty01', { y: "30%", scale: 0.8});
  gsap.to('#cloud-empty01', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 2,
    },
    y: "-50%",
  });

  gsap.set('#cloud-empty02', { y: "-60%", scale: 0.8});
  gsap.to('#cloud-empty02', {
    scrollTrigger: {
      trigger: '.overview-block',
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1,
    },
    y: "10%",
  });

  setTimeout(() => {
    gsap.to('#cloud', {
      opacity: 1,
      duration: 0.4,
      ease: "power2.inOut",
    });
    gsap.to('#cloud01', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
    gsap.to('#cloud02', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
    gsap.to('#cloud03', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
    gsap.to('#cloud04', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
    gsap.to('#cloud-empty01', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
    gsap.to('#cloud-empty02', {
      scale: 1,
      duration: 1,
      ease: "power3.out",
    });
  }, 1000);
}
